import { HoldingsTableColumn } from './holdings.model';

export const HOLDINGS_OPTIONS = {
  FULL: 'full',
  TOP_TEN: 'top-ten',
} as const;

export const FREQUENCIES = {
  MONTH: 'month',
  QUARTER: 'quarter',
} as const;

const HOLDING_NAME_KEY = 'name';
const HOLDING_SECTOR_NAME_KEY = 'sectorName';
const HOLDING_INDUSTRY_NAME_KEY = 'industryName';
const HOLDING_MARKET_VALUE_KEY = 'marketValue';
const HOLDING_PERCENTAGE_TOTAL_NET_ASSETS_KEY = 'percentageTotalNetAssets';
const HOLDING_PERCENTAGE_CHANGE_KEY = 'percentageChange';
const HOLDING_COUPON_RATE_KEY = 'holdingCouponRate';
const HOLDING_MATURITY_DATE_KEY = 'holdingMaturityDate';

export const HOLDING_COLUMN_ID = 'holding';
export const SECTOR_COLUMN_ID = 'sector';
export const INDUSTRY_COLUMN_ID = 'industry';
export const MARKET_VALUE_COLUMN_ID = 'market-value';
export const PERCENT_OF_PORTFOLIO_COLUMN_ID = 'percent-of-portfolio';
export const PERCENT_CHANGE_COLUMN_ID = 'percent-change';
export const HOLDING_COUPON_RATE_COLUMN_ID = 'holding-coupon-rate';
export const HOLDING_MATURITY_DATE_COLUMN_ID = 'holding-maturity-date';

const HOLDING_COLUMN_LABEL = 'Holding';
const SECTOR_COLUMN_LABEL = 'Sector';
const INDUSTRY_COLUMN_LABEL = 'Industry';
const MARKET_VALUE_COLUMN_LABEL = 'Market value';
const PERCENT_OF_PORTFOLIO_COLUMN_LABEL = '% of portfolio';
const PERCENT_CHANGE_FROM_LAST_PERIOD_COLUMN_LABEL =
  '% change from previous period';
const HOLDING_COUPON_RATE_COLUMN_LABEL = 'Coupon %';
const HOLDING_MATURITY_DATE_COLUMN_LABEL = 'Maturity';

const TABLE_COLUMNS: HoldingsTableColumn[] = [
  {
    key: HOLDING_NAME_KEY,
    id: HOLDING_COLUMN_ID,
    label: HOLDING_COLUMN_LABEL,
    rightAlign: false,
  },
  {
    key: HOLDING_SECTOR_NAME_KEY,
    id: SECTOR_COLUMN_ID,
    label: SECTOR_COLUMN_LABEL,
    rightAlign: false,
  },
  {
    key: HOLDING_INDUSTRY_NAME_KEY,
    id: INDUSTRY_COLUMN_ID,
    label: INDUSTRY_COLUMN_LABEL,
    rightAlign: false,
  },
  {
    key: HOLDING_MARKET_VALUE_KEY,
    id: MARKET_VALUE_COLUMN_ID,
    label: MARKET_VALUE_COLUMN_LABEL,
    rightAlign: true,
  },
  {
    key: HOLDING_MATURITY_DATE_KEY,
    id: HOLDING_MATURITY_DATE_COLUMN_ID,
    label: HOLDING_MATURITY_DATE_COLUMN_LABEL,
    rightAlign: false,
  },
  {
    key: HOLDING_COUPON_RATE_KEY,
    id: HOLDING_COUPON_RATE_COLUMN_ID,
    label: HOLDING_COUPON_RATE_COLUMN_LABEL,
    rightAlign: true,
  },
  {
    key: HOLDING_PERCENTAGE_TOTAL_NET_ASSETS_KEY,
    id: PERCENT_OF_PORTFOLIO_COLUMN_ID,
    label: PERCENT_OF_PORTFOLIO_COLUMN_LABEL,
    rightAlign: true,
  },
  {
    key: HOLDING_PERCENTAGE_CHANGE_KEY,
    id: PERCENT_CHANGE_COLUMN_ID,
    label: PERCENT_CHANGE_FROM_LAST_PERIOD_COLUMN_LABEL,
    rightAlign: true,
  },
];

export const Constants = {
  TAG_NAME: 'pop-holdings-component',
  NESTED_COMPONENTS: [
    'pop-holdings-table-component',
    'pop-no-data-available-component',
  ],
  HOLDINGS_OPTIONS: [HOLDINGS_OPTIONS.FULL, HOLDINGS_OPTIONS.TOP_TEN],
  DEFAULT_HOLDINGS_OPTION: HOLDINGS_OPTIONS.FULL,
  FREQUENCIES: [FREQUENCIES.MONTH, FREQUENCIES.QUARTER],
  DEFAULT_FREQUENCY: FREQUENCIES.QUARTER,
  NOT_APPLICABLE: 'N/A',
  HOLDINGS_UNAVAILABLE: 'Holdings unavailable',
  HOLDINGS_LABEL: 'Holdings',
  DISCLAIMER_CODE: 'SMA-GlobalSecDiv',
  DISCLAIMER_CODE_FIXED_INCOME: 'SMA-GlobalPortHold',
  DATA_AS_OF: 'Data as of',
  FULL_HOLDINGS_AS_OF_DATE_SELECT_ID: 'full-holdings-as-of-date-select',
  FULL_HOLDINGS_SEARCH_INPUT_ID: 'full-holdings-search-input',
  FULL_HOLDINGS_SEARCH_LABEL: 'Search ticker, name, sector, or industry',
  FULL_HOLDINGS_SEARCH_DESCRIPTION: 'Holdings will be filtered as you type',
  TOP_TEN_HOLDINGS_AS_OF_DATE_SELECT_ID: 'top-ten-holdings-as-of-date-select',
  ROWS_PER_PAGE: 10,
  CONTENT_BELOW_TABLE_ID: 'content-below-table',
  HOLDING_NAME_KEY,
  HOLDING_SECTOR_NAME_KEY,
  HOLDING_INDUSTRY_NAME_KEY,
  HOLDING_MARKET_VALUE_KEY,
  HOLDING_MATURITY_DATE_KEY,
  HOLDING_COUPON_RATE_KEY,
  HOLDING_PERCENTAGE_TOTAL_NET_ASSETS_KEY,
  HOLDING_PERCENTAGE_CHANGE_KEY,
  HOLDING_COLUMN_ID,
  SECTOR_COLUMN_ID,
  INDUSTRY_COLUMN_ID,
  MARKET_VALUE_COLUMN_ID,
  HOLDING_MATURITY_DATE_COLUMN_ID,
  HOLDING_COUPON_RATE_COLUMN_ID,
  PERCENT_OF_PORTFOLIO_COLUMN_ID,
  PERCENT_CHANGE_COLUMN_ID,
  HOLDING_COLUMN_LABEL,
  SECTOR_COLUMN_LABEL,
  INDUSTRY_COLUMN_LABEL,
  MARKET_VALUE_COLUMN_LABEL,
  HOLDING_MATURITY_DATE_COLUMN_LABEL,
  HOLDING_COUPON_RATE_COLUMN_LABEL,
  PERCENT_OF_PORTFOLIO_COLUMN_LABEL,
  PERCENT_CHANGE_FROM_LAST_PERIOD_COLUMN_LABEL,
  TABLE_COLUMNS,
} as const;
